import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { of } from 'rxjs'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import useObservable from 'libraries/front-end-core/hooks/useObservable'
import { requestSectionDocuments } from 'services/DocumentService'
import { requestUserFavourites } from 'services/FavouritesService'
import { DOCUMENTS_FAVOURITING } from 'constants/feature-flags'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import SectionDetails from './SectionDetails'
import { setSelectedDocuments } from 'redux/actions'

const SectionDetailsPage = (props) => {
  const showAutomatedOnly = useSelector(state => state.documents.showAutomatedOnly)
  const data = useObservable(
    requestSectionDocuments(props.sectionId, props.aol, showAutomatedOnly),
    RESPONSE_PENDING,
    [showAutomatedOnly]
  )
  const documentFavourites = useObservable(
    DOCUMENTS_FAVOURITING ? requestUserFavourites('documents') : of([]),
    RESPONSE_PENDING
  )
  const dispatch = useDispatch()

  useEffect(() => {
    return () => dispatch(setSelectedDocuments([]))
  }, [])

  return (
    <ResponseConsumer
      response={data}
      content={() => (
        <SectionDetails
          {...props}
          data={data}
          documentFavourites={Array.isArray(documentFavourites) ? documentFavourites : []}
        />
      )}
    />
  )
}

export default SectionDetailsPage
